import { EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { ItemBase } from '../../../models/item/item-base';
import { ColumnDirective } from '../column/column.directive';
// @Component({
// 	moduleId: module.id.toString(),
// 	selector: '',
// 	template: '',
// 	styles: []
// })
var ColumnBaseComponent = /** @class */ (function () {
    function ColumnBaseComponent(service, baseService) {
        this.service = service;
        this.baseService = baseService;
        this.componentName = '';
        this.changeVal = new EventEmitter();
        this.clickCol = new EventEmitter();
        this.colKey = '';
        this.changeValFlg = false;
    }
    ColumnBaseComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.colKey = this.baseService.getColKey(this.componentName, this.col.key, this.index);
        this.subsc = this.service.observable.subscribe(function (data) {
            if (data.flg && _this.dir && (!_this.componentName || data.targetComponents.length === 0 || data.targetComponents.indexOf(_this.componentName) >= 0)) {
                _this.changeValFlg = data.clear ? false : true;
                _this.addError();
            }
        });
        this.validSubsc = this.service.validationObservable.subscribe(function (data) {
            if (typeof data.error !== 'undefined' && _this.dir && (!_this.componentName || data.targetComponents.length === 0 || data.targetComponents.indexOf(_this.componentName) >= 0)) {
                _this.dir.addValidationError(data.error);
            }
        });
    };
    ColumnBaseComponent.prototype.ngOnChanges = function (changes) {
        if (this.dir) {
            this.addError();
        }
    };
    ColumnBaseComponent.prototype.onChange = function (e, changeFlg) {
        if (changeFlg === void 0) { changeFlg = true; }
        this.changeValFlg = changeFlg;
        this.changeVal.emit({ key: this.col.key, val: e });
    };
    ColumnBaseComponent.prototype.onClick = function (e, t) {
        this.clickCol.emit({ controlType: this.col.controlType, event: e, type: t });
    };
    ColumnBaseComponent.prototype.addError = function () {
        var errs = [];
        if (this.changeValFlg) {
            errs = this.checkVal();
        }
        this.dir.addErrors(errs.concat(this.err || []));
        this.changeValFlg = false;
    };
    ColumnBaseComponent.prototype.checkVal = function () {
        return this.service.checkRequired(this.col, this.val) ? [] : [this.msg['ColumnComponent.error.required']];
    };
    ColumnBaseComponent.prototype.trackByOption = function (index, option) {
        return option.code;
    };
    ColumnBaseComponent.prototype.ngOnDestroy = function () {
        if (this.subsc) {
            this.subsc.unsubscribe();
        }
        if (this.validSubsc) {
            this.validSubsc.unsubscribe();
        }
    };
    ColumnBaseComponent.propDecorators = {
        key: [{ type: Input }],
        componentName: [{ type: Input }],
        index: [{ type: Input }],
        cls: [{ type: Input }],
        col: [{ type: Input }],
        val: [{ type: Input }],
        msg: [{ type: Input }],
        err: [{ type: Input }],
        changeVal: [{ type: Output }],
        clickCol: [{ type: Output }],
        dir: [{ type: ViewChild, args: [ColumnDirective,] }]
    };
    return ColumnBaseComponent;
}());
export { ColumnBaseComponent };
//# sourceMappingURL=columnbase.component.js.map